import React from "react";
import { useNavigate } from "react-router-dom";
import EventCard from "./EventCard";
import "../style/EventsSection.css";
import events from "../data/events";

const EventsSection = () => {
  const navigate = useNavigate();

  return (
    <section className="events-wrapper" id="events">
      <h2 className="events-title">Events</h2>
      <div className="events-section">
        {events.map((event) => (
          <EventCard key={event.id} {...event} onClick={() => navigate(`/event/${event.id}`)} />
        ))}
      </div>
    </section>
  );
};

export default EventsSection;
